<template>
    <div class="teachers">
        <top :keyword="''" :tab="'teacher'"></top>
        <div style="width: 1233px;margin: 0 auto;text-align: left;">
            <ul class="national-designer">
                <li
                    class="young-fellow"
                    style="cursor: pointer;"
                    v-for="teacher in teachers"
                    :key="teacher.id"
                >
                    <div class="head-image" :style="{backgroundImage: backgroundImage(teacher)}"></div>
                    <div class="towards-right">
                        <span style="font-size: 20px">{{ teacher.name }}</span>
                        <p></p>
                        <div class="medal-lecturer">
                            <i class="iconfont"></i>
                            <p>{{ teacher.profession }} - {{ teacher.levelName }}</p>
                        </div>
                        <div class="introduction">
                            <h2>简介：</h2>
                            <p>{{ teacher.teacherDesc }}</p>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <div class="paging" v-show="totalPage > 0">
            <div class="paging-box">
                <a @click="prev">
                    <i class="icon-prev"></i>
                </a>
                <a
                    @click="toPage(item)"
                    :class="{curr :item == page, num : item != page}"
                    v-for="item in pages"
                    :key="item.id"
                >{{ item }}</a>
                <a @click="next">
                    <i class="icon-next"></i>
                </a>
            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from './top'
import bottom from './bottom'

export default {
    name: 'teacher',
    data() {
        return {
            page: 1,
            teachers: [],
            totalPage: 0,
            pages: []
        }
    },
    computed: {},
    methods: {
        list() {
            this.$http
                .get(this.$cmsPath + '/course/teachers?page=' + this.page)
                .then(result => {
                    this.teachers = result.data.rows
                    this.totalPage = Math.ceil(result.data.total / 10)
                    let pages = []
                    for (let i = this.page - 2; i <= this.page + 2; i++) {
                        if (i > 1 && i < this.totalPage) {
                            pages.push(i)
                        }
                    }
                    pages.unshift(1)
                    pages.push(this.totalPage)
                    this.pages = pages
                })
        },
        next() {
            if (this.page < this.totalPage) {
                this.page += 1
                this.list()
            }
        },
        prev() {
            if (this.page > 1) {
                this.page -= 1
                this.list()
            }
        },
        backgroundImage(teacher) {
            return 'url(' + teacher.photoUrl + ')'
        },
        toPage(page) {
            this.page = page
            this.list()
        }
    },
    created() {
        this.list()
    },
    components: {
        bottom: bottom,
        top: top
    }
}
</script>
<style scoped>
@import '../assets/css/iconfont.css';
@import '../assets/css/common.css';
@import '../assets/css/index.css';
@import '../assets/css/cms.css';
</style>



// WEBPACK FOOTER //
// src/views/teacher.vue